import { unsubscribeUrl } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';

export const UnsubscribeService = {
  unsubscribe(customer: string, type: string, emailSubscription: string) {
    return _http.HttpPost(
      unsubscribeUrl.replace('{0}', customer).replace('{1}', type).replace('{2}', emailSubscription)
    );
  },
};
